'use strict';

(function () {
  var builder = document.querySelector('.builder__slides');

  if (!builder) {
    return;
  }

  var builderItem = builder.querySelectorAll('.builder__item');
  var next = document.querySelector('.builder__next');
  var indicator = document.querySelector('.builder__indicator > div:first-child');

  // slide
  var nextSlide = function nextSlide() {
    var activeClass = 'is-active';
    var activeLastClass = 'is-last-active';
    var currentSlide = document.querySelector('.is-active');
    var nextSlide = currentSlide.nextElementSibling;

    if (nextSlide !== null) {
      nextSlide.classList.add(activeClass);

      if (window.innerWidth < 960) {
        currentSlide.classList.remove(activeClass);
      } else {
        window.setTimeout(function () {
          currentSlide.classList.remove(activeClass);
        }, 750);
      }
    } else {
      currentSlide.classList.remove(activeClass);
      builder.firstElementChild.classList.add(activeClass);
      builder.lastElementChild.classList.add(activeLastClass);

      if (window.innerWidth < 960) {
        builder.lastElementChild.classList.remove(activeLastClass);
      } else {
        window.setTimeout(function () {
          builder.lastElementChild.classList.remove(activeLastClass);
        }, 750);
      }
    }
  };

  // indicator
  var nextIndicator = function nextIndicator() {
    var activeClass = 'indicator-is-active';
    var hiddenClass = 'indicator-is-hidden';
    var currentIndicator = document.querySelector('.indicator-is-active');
    var nextIndicator = currentIndicator.nextElementSibling;

    if (nextIndicator !== null) {
      currentIndicator.classList.add(hiddenClass);
      currentIndicator.classList.remove(activeClass);
      nextIndicator.classList.remove(hiddenClass);
      nextIndicator.classList.add(activeClass);
    } else {
      currentIndicator.classList.add(hiddenClass);
      currentIndicator.classList.remove(activeClass);
      indicator.firstElementChild.classList.remove(hiddenClass);
      indicator.firstElementChild.classList.add(activeClass);
    }
  };

  // events
  next.addEventListener('click', function () {
    nextSlide();
    nextIndicator();
  });

  next.addEventListener('keydown', function (e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      nextSlide();
      nextIndicator();
      e.preventDefault();
    }
  });
})();